import Swal from 'sweetalert2';

const messages = {
    success: {
        title: 'Success!',
        icon: 'success'
    },
    warning: {
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!'
    }
};


Object.entries(messages)
    .forEach(([key, config]) => {
        Swal.fire[key] = async function(opts = {}) {
            return await Swal.fire(Object.assign(opts, config));
        };
    });


export default Swal;
